import React from 'react';
import './Topbar.css';

const Topbar = () => {
  return (
    <div className="container-fluid px-5 py-3 d-none d-lg-block" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="row gx-0 align-items-center justify-content-between">
        <div className="col-lg-2">
          <div className="d-inline-flex align-items-center">
            <a href="/" className="navbar-brand p-0">
              <img src="/assets/Galaxypower logo.png" alt="Logo" style={{ height: '70px' }} />
            </a>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="d-flex align-items-center">
            <i className="fas fa-map-marker-alt me-3" style={{ fontSize: '1.5rem', minWidth: '30px', color: '#DE400E' }}></i>
            <div>
              <h6 className="text-dark fw-bold mb-1" style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>OUR LOCATION</h6>
              <p className="text-muted mb-0" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
                33/A1, VGP St,<br />Chidambaram - 608601, Cuddalore(Dt), Tamil Nadu.
              </p>
            </div>
          </div>
        </div>

        <div className="col-lg-3">
          <div className="d-flex align-items-center">
            <i className="fas fa-clock me-3" style={{ fontSize: '1.5rem', minWidth: '30px', color: '#DE400E' }}></i>
            <div>
              <h6 className="text-dark fw-bold mb-1" style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>OPENING TIME</h6>
              <p className="text-muted mb-0" style={{ fontSize: '0.8rem', lineHeight: '1.4' }}>
                Mon - Sat: 09:00AM - 09:00PM<br />Sunday: Holiday
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;